(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/race-navigation/assets/javascripts/use-navigation-actions.js') >= 0) return;  svs.modules.push('/components/racing/race-navigation/assets/javascripts/use-navigation-actions.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const navigate = svs.racing.navigation.navigate;
const useNavigationActions = () => {
  const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const actions = useMemo(() => navigate(match, location, history), [history, location, match]);
  return actions;
};
setGlobal('svs.racing.navigation.useNavigationActions', useNavigationActions);

 })(window);